import { EmptyList } from 'components/core/empty-list'
import { C1TableReduxHook } from 'components/core/list/C1Table/C1TableReduxHook'
import { colsMap, TaskListColumnsV2, TaskListV2Extras } from 'components/core/task-list-v2/TaskListV2'
import { TaskValue } from 'lib/actions/task'
import { ListRelatedTasksRequest } from 'pbts/c1/api/task/v1/binding'
import { FC, useMemo } from 'react'
import { listRelatedTasks } from 'redux_toolkit/tasks'

export const RelatedTaskListV2: FC<{
    taskId: string
}> = ({ taskId }) => {
    const cols = useMemo(() => {
        const columns = [
            TaskListColumnsV2.viewLink,
            TaskListColumnsV2.account,
            TaskListColumnsV2.app,
            TaskListColumnsV2.entitlement,
            TaskListColumnsV2.assignedTo,
            TaskListColumnsV2.actions,
        ]
        return columns.map((col) => colsMap[col]) || []
    }, [])

    return <C1TableReduxHook<ListRelatedTasksRequest, TaskValue, TaskListV2Extras>
        request={ListRelatedTasksRequest.create({ referenceTaskId: taskId, expandMask: { paths: ['*'] } })}
        hook={listRelatedTasks.useListRelatedTasks}
        cols={cols}
        emptyState={<EmptyList />}
        invalidateHook={listRelatedTasks.useInvalidateListRelatedTasks}
    />
}
